import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  IPartBomItem,
  IPartBomItemListRequestPayload,
  IUpsertPartBomItemPayload,
} from 'partBoms/types';
import { IPart } from 'parts/types';

export const getPartBomItems = async (
  requestPayload: IPartBomItemListRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IPartBomItem>> => {
  const { data } = await partfinitiClient.get(
    `/part_v2/bom-item-list/items?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IPartBomItem>(data.data, data.recordsFiltered, data.totals);
};

export const upsertPartBomItem = async (data: IUpsertPartBomItemPayload) =>
  partfinitiClient.postForm('/part_v2/bom-item-edit/save', data, {
    includeNullValues: true,
  });

export const validatePart = async (
  payload: {
    number: string;
    manufacturerId: number;
  },
  signal?: AbortSignal
): Promise<GetOneResponse<IPart>> => {
  const { data } = await partfinitiClient.get(
    `/part_v2/bom-item-edit/validate-part?${getQueryStringToSnakeCase(payload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IPart>(data.part, data.success, data.uoms);
};

export const removePartBomItems = async (data: { ids: number[] }) =>
  await partfinitiClient.postForm('/part_v2/bom-item-edit/remove', data);
